import { orderStatuses, orderTypes } from "../constants";
import {
  dateAfterDeliveryDate,
  dateBeforeMidnightOfCreationDate,
} from "./utilities";

//only if there is not already an existing concern, need to confirm for order types
export const canSubmitDeliveryConcern = (concernNo) => {
  const existingConcern = concernNo > 0;
  if (existingConcern) {
    return {
      ableTo: false,
      reason: "There is already an existing delivery concern for this order.",
    };
  } else {
    return {
      ableTo: true,
      reason: "",
    };
  }
};
export const canFileClaim = (status, claimID) => {
  // const status = deliveryInfo.status;
  const existingClaim = claimID > 0;
  //for a while we were debating about whether to make the ability to file a claim or request a return available after the delivery date, to reduce the need for manual fix ups when an order somehow got delivered but never scanned
  // &&
  // !dateAfterDeliveryDate(
  //   new Date(deliveryInfo.deliveryDate),
  //   new Date()
  // )

  //can file claim if
  //status != open
  if (status === orderStatuses.open) {
    return {
      ableTo: false,
      reason: "This action is not supported for open orders.",
    };
  }
  if (existingClaim) {
    return {
      ableTo: false,
      reason: "There is already an existing claim on this order.",
    };
  } else {
    return {
      ableTo: true,
      reason: "",
    };
  }
  // const canFileClaim = status !== orderStatuses.open;
  // return {
  //   ableTo: canFileClaim,
  //   reason: canFileClaim ? "" : "This action is not supported for open orders.",
  // };
};

export const canRequestReturn = (status, orderType, returnDeliveryID) => {
  //in the delivery menu we will not pass the return delivery id for this function as it has its own logic in case there is one (it displays that there is already a return and shows the id of the return order)
  // const existingReturn = returnDeliveryID ? returnDeliveryID > 0 : false;
  // &&
  // !dateAfterDeliveryDate(
  //   new Date(deliveryInfo.deliveryDate),
  //   new Date()
  // )

  // can request return if
  //orderType != return or buyout
  //status != open
  if (orderType === orderTypes.return || orderType === orderTypes.buyout) {
    return {
      ableTo: false,
      reason: "This action is not supported for returns or buy outs.",
    };
  } else if (status === orderStatuses.open) {
    return {
      ableTo: false,
      reason: "This action is not supported for open orders.",
    };
  } else {
    return {
      ableTo: true,
      reason: "",
    };
  }

  /*
else if (existingReturn) {
    return {
      ableTo: false,
      reason: "There is already an existing return for this order.",
    };
  }
  */
};
export const canInitiateCODResearch = (status, deliveryDate, isCod) => {
  //can initiate if:
  //orderType = regular for now, but not checking for this as isCod will only be true for those anyway
  //and isCod
  //and status != open
  //and delivery date has passed or there is a delivery scan
  if (!isCod) {
    return {
      ableTo: false,
      reason: "This action is only supported for COD orders.",
    };
  }
  if (status === orderStatuses.open) {
    return {
      ableTo: false,
      reason: "This action is not supported for open orders.",
    };
  } else if (
    !dateAfterDeliveryDate(deliveryDate, new Date()) &&
    !status.includes(orderStatuses.delivered)
  ) {
    return {
      ableTo: false,
      reason: "This action is not supported until after the delivery date.",
    };
  }
  return {
    ableTo: true,
    reason: "",
  };
};
export const canModify = (status, creationDate, orderType) => {
  //can modify if:
  //order type = regular
  //and status = open
  //and not currently passed midnight of creation date
  if (orderType !== orderTypes.regular) {
    return {
      ableTo: false,
      reason: "This action is not supported for returns or buy outs.",
    };
  } else if (status !== orderStatuses.open) {
    return {
      ableTo: false,
      reason: "This action cannot be performed after the order is in transit.",
    };
  } else if (!dateBeforeMidnightOfCreationDate(creationDate, new Date())) {
    return {
      ableTo: false,
      reason: "This action is not supported after the modification period.",
    };
  } else {
    return {
      ableTo: true,
      reason: "",
    };
  }
};

export const canVoid = (status, creationDate, orderType) => {
  //can void if
  //order type != return
  //and status = open
  //and not currently after midnight of creation date
  if (orderType === orderTypes.return) {
    return {
      ableTo: false,
      reason: "This action is not supported for returns.",
    };
  } else if (status !== orderStatuses.open) {
    return {
      ableTo: false,
      reason: "This action cannot be performed after the order is in transit.",
    };
  } else if (!dateBeforeMidnightOfCreationDate(creationDate, new Date())) {
    return {
      ableTo: false,
      reason: "This action is not supported after the modification period.",
    };
  } else {
    return {
      ableTo: true,
      reason: "",
    };
  }
};
